"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENTS = exports.NOTIFICATION = exports.ProposedEventNames = exports.VideoEventType = exports.SpaceEventType = exports.GroupEventType = exports.MessageEventType = exports.MessageOrigin = exports.NotificationEventType = exports.STREAM = void 0;
var STREAM;
(function (STREAM) {
    STREAM["PROFILE"] = "STREAM.PROFILE";
    STREAM["ENCRYPTION"] = "STREAM.ENCRYPTION";
    STREAM["NOTIF"] = "STREAM.NOTIF";
    STREAM["NOTIF_OPS"] = "STREAM.NOTIF_OPS";
    STREAM["CHAT"] = "STREAM.CHAT";
    STREAM["CHAT_OPS"] = "STREAM.CHAT_OPS";
    STREAM["SPACE"] = "STREAM.SPACE";
    STREAM["SPACE_OPS"] = "STREAM.SPACE_OPS";
    STREAM["VIDEO"] = "STREAM.VIDEO";
    STREAM["CONNECT"] = "STREAM.CONNECT";
    STREAM["DISCONNECT"] = "STREAM.DISCONNECT";
})(STREAM = exports.STREAM || (exports.STREAM = {}));
var NotificationEventType;
(function (NotificationEventType) {
    NotificationEventType["INBOX"] = "notification.inbox";
    NotificationEventType["SPAM"] = "notification.spam";
})(NotificationEventType = exports.NotificationEventType || (exports.NotificationEventType = {}));
var MessageOrigin;
(function (MessageOrigin) {
    MessageOrigin["Other"] = "other";
    MessageOrigin["Self"] = "self";
})(MessageOrigin = exports.MessageOrigin || (exports.MessageOrigin = {}));
var MessageEventType;
(function (MessageEventType) {
    MessageEventType["Message"] = "message";
    MessageEventType["Request"] = "request";
    MessageEventType["Accept"] = "accept";
    MessageEventType["Reject"] = "reject";
})(MessageEventType = exports.MessageEventType || (exports.MessageEventType = {}));
var GroupEventType;
(function (GroupEventType) {
    GroupEventType["CreateGroup"] = "createGroup";
    GroupEventType["UpdateGroup"] = "updateGroup";
    GroupEventType["JoinGroup"] = "joinGroup";
    GroupEventType["LeaveGroup"] = "leaveGroup";
    GroupEventType["Remove"] = "remove";
    GroupEventType["RoleChange"] = "roleChange";
})(GroupEventType = exports.GroupEventType || (exports.GroupEventType = {}));
var SpaceEventType;
(function (SpaceEventType) {
    SpaceEventType["CreateSpace"] = "createSpace";
    SpaceEventType["UpdateSpace"] = "updateSpace";
    SpaceEventType["Join"] = "joinSpace";
    SpaceEventType["Leave"] = "leaveSpace";
    SpaceEventType["Remove"] = "remove";
    SpaceEventType["Stop"] = "stop";
    SpaceEventType["Start"] = "start";
})(SpaceEventType = exports.SpaceEventType || (exports.SpaceEventType = {}));
var VideoEventType;
(function (VideoEventType) {
    VideoEventType["REQUEST"] = "video.request";
    VideoEventType["APPROVE"] = "video.approve";
    VideoEventType["DENY"] = "video.deny";
    VideoEventType["CONNECT"] = "video.connect";
    VideoEventType["DISCONNECT"] = "video.disconnect";
    // retry events
    VideoEventType["RETRY_REQUEST"] = "video.retry.request";
    VideoEventType["RETRY_APPROVE"] = "video.retry.approve";
})(VideoEventType = exports.VideoEventType || (exports.VideoEventType = {}));
var ProposedEventNames;
(function (ProposedEventNames) {
    ProposedEventNames["Message"] = "chat.message";
    ProposedEventNames["Request"] = "chat.request";
    ProposedEventNames["Accept"] = "chat.accept";
    ProposedEventNames["Reject"] = "chat.reject";
    ProposedEventNames["LeaveGroup"] = "chat.group.participant.leave";
    ProposedEventNames["JoinGroup"] = "chat.group.participant.join";
    ProposedEventNames["CreateGroup"] = "chat.group.create";
    ProposedEventNames["UpdateGroup"] = "chat.group.update";
    ProposedEventNames["Remove"] = "chat.group.participant.remove";
    ProposedEventNames["RoleChange"] = "chat.group.participant.role";
    ProposedEventNames["CreateSpace"] = "space.create";
    ProposedEventNames["UpdateSpace"] = "space.update";
    ProposedEventNames["SpaceRequest"] = "space.request";
    ProposedEventNames["SpaceAccept"] = "space.accept";
    ProposedEventNames["SpaceReject"] = "space.reject";
    ProposedEventNames["LeaveSpace"] = "space.participant.leave";
    ProposedEventNames["JoinSpace"] = "space.participant.join";
    ProposedEventNames["SpaceRemove"] = "space.participant.remove";
    ProposedEventNames["StartSpace"] = "space.start";
    ProposedEventNames["StopSpace"] = "space.stop";
})(ProposedEventNames = exports.ProposedEventNames || (exports.ProposedEventNames = {}));
exports.NOTIFICATION = {
    TYPE: {
        BROADCAST: 1,
        TARGETTED: 3,
        SUBSET: 4,
    },
};
var EVENTS;
(function (EVENTS) {
    // Websocket
    EVENTS["CONNECT"] = "connect";
    EVENTS["DISCONNECT"] = "disconnect";
    // Notification
    EVENTS["USER_FEEDS"] = "userFeeds";
    EVENTS["USER_SPAM_FEEDS"] = "userSpamFeeds";
    // Chat
    EVENTS["CHAT_RECEIVED_MESSAGE"] = "CHATS";
    EVENTS["CHAT_GROUPS"] = "CHAT_GROUPS";
})(EVENTS = exports.EVENTS || (exports.EVENTS = {}));
//# sourceMappingURL=pushStreamTypes.js.map